import { render, staticRenderFns } from "./DomainEvents.vue?vue&type=template&id=dd30d036"
import script from "./DomainEvents.vue?vue&type=script&lang=js"
export * from "./DomainEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports